export { default as rootStore } from "./rootStore"
